import App from "./App";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { Msal2Provider } from "@microsoft/mgt-msal2-provider";
import { LoginType, Providers } from "@microsoft/mgt-element";
import { msalConfig } from "./config";
import { MgtPerson, MgtPersonCard } from "@microsoft/mgt-react";

//msal2 provider to sign in using azure ad
Providers.globalProvider = new Msal2Provider({
  clientId: msalConfig.auth.clientId,
  scopes: msalConfig.auth.scopes,
  authority: msalConfig.auth.authority,
  redirectUri: msalConfig.auth.redirectUri,
  loginType: LoginType.Redirect,
});

MgtPerson.config.useContactApis = false;
MgtPersonCard.config.useContactApis = false;
MgtPersonCard.config.sections = {
  profile: true,
  organization: false,
  files: false,
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
